import React, { useState, useEffect, useContext } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useMutation, useManualQuery, ClientContext } from "graphql-hooks";

import {
  Container,
  Card,
  CardContent,
  Grid,
  Typography,
  Divider,
  TextField,
  Radio,
  Checkbox,
  Tooltip,
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  makeStyles,
} from "@material-ui/core";
import Box from "@mui/material/Box";

import HeaderTenent from "./tenants/Header.js";
import HeaderApplicant from "./applicantUsers/Header.js";

import { project_url } from "../constants/Data";

const useStyles = makeStyles(theme => ({
  root: {
    marginRight: "8rem",
    textAlign: "center",
    padding: theme.spacing(2),
    paddingLeft: 0,
    paddingRight: 0,
    width: "1400px",
    paddingTop: "7.5rem",
    //  minWidth: "500px",
  },
  container: {
    padding: theme.spacing(4),
    marginTop: "1rem",
    marginBottom: "5rem",
    overflow: "hidden",
    clear: "both",
    borderRadius: "8px",
    height: "870px",
    backgroundColor: "#ffffff",
  },
}));

function ToBeDev() {
  const classes = useStyles();

  const [loc, setLoc] = useState(null);
  const location = useLocation();
  useEffect(() => {
    if (location.pathname.indexOf(`${project_url}/tenant`) != -1) setLoc("tenant");
    else if (location.pathname.indexOf(`${project_url}/applicant`) != -1) setLoc("applicant");
  }, [location]);
  return (
    <div className={classes.root}>
      {loc === "tenant" && <HeaderTenent />}
      {loc === "applicant" && (
        <HeaderApplicant breadcrumbs={[{ label: "Members", link: null }]} />
      )}
      <div className={classes.container}>
        <Typography variant="h1">Under Construction</Typography>
      </div>
    </div>
  );
}

export default ToBeDev;
